type RunPayload = {
  code: string;
  language: string;
  originUrl?: string;
  createdAt: number;
};

type RunPayloadWithId = RunPayload & { id: string };

const DB_NAME = 'oreog-runner';
const DB_VERSION = 1;
const STORE_NAME = 'runs';

const openDb = () => {
  return new Promise<IDBDatabase>((resolve, reject) => {
    const req = indexedDB.open(DB_NAME, DB_VERSION);

    req.onupgradeneeded = () => {
      const db = req.result;
      if (!db.objectStoreNames.contains(STORE_NAME)) {
        db.createObjectStore(STORE_NAME, { keyPath: 'id' });
      }
    };

    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
};

export const putRunPayload = async (id: string, payload: RunPayload) => {
  const db = await openDb();
  return new Promise<void>((resolve, reject) => {
    const tx = db.transaction(STORE_NAME, 'readwrite');
    const store = tx.objectStore(STORE_NAME);
    store.put({ ...payload, id } satisfies RunPayloadWithId);

    tx.oncomplete = () => {
      db.close();
      resolve();
    };
    tx.onerror = () => {
      db.close();
      reject(tx.error);
    };
  });
};

export const getRunPayload = async (id: string) => {
  const db = await openDb();
  return new Promise<RunPayload | null>((resolve, reject) => {
    const tx = db.transaction(STORE_NAME, 'readonly');
    const store = tx.objectStore(STORE_NAME);
    const req = store.get(id);

    req.onsuccess = () => {
      const result = req.result as RunPayloadWithId | undefined;
      db.close();
      if (!result) return resolve(null);

      const { id: _id, ...rest } = result;
      resolve(rest);
    };

    req.onerror = () => {
      db.close();
      reject(req.error);
    };
  });
};

export const deleteRunPayload = async (id: string) => {
  const db = await openDb();
  return new Promise<void>((resolve, reject) => {
    const tx = db.transaction(STORE_NAME, 'readwrite');
    const store = tx.objectStore(STORE_NAME);
    store.delete(id);

    tx.oncomplete = () => {
      db.close();
      resolve();
    };
    tx.onerror = () => {
      db.close();
      reject(tx.error);
    };
  });
};
